import { useMemo } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import * as server from 'js/components/main/Jumio/server';
import { getRedirectUrl, handleRedirect } from 'js/components/main/Jumio/helpers';

const getVerifyNow = isLoggedIn => (options) => {
    if (!isLoggedIn) {
        return Promise.reject(new Error('Jumio Public API: User must be logged in.'));
    }

    return server.verifyNow(options);
};

export const useJumioPublicAPI = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return useMemo(() => ({
        /**
         * Retrieve jumio redirect url.
         * @memberOf Playtech.API.jumio
         * @function
         * @param type {String}
         * @returns {String}
         * @example
         * // 'https://core3-qa09.mws.playtechgaming.com/en/?jumioVerify=test'
         * Playtech.API.jumio.getRedirectUrl('test');
         */
        getRedirectUrl,
        /**
         * Perform 'handleJumioRedirect'-function from window.Playtech.API if provided by licensee or redirect to provided here url.
         * @memberOf Playtech.API.jumio
         * @function
         * @param url {String}
         * @example
         * Playtech.API.jumio.handleRedirect('https://www.example.com');
         */
        handleRedirect,
        /**
         * Perform Initiate document upload request.
         * @memberOf Playtech.API.jumio
         * @function
         * @param options {Object} Fields for request.
         * @param options.successUrl {String}
         * @param options.errorUrl {String}
         * @param [options.documentType] {String} Examples of document type: PASSPORT, DRIVING_LICENCE, ID_CARD, CCS, BS, UB.
         * @returns {Promise<{ID: Number, data: {correlationId: String, redirectURL: String, reference: String}}>}
         * @example
         * Playtech.API.jumio.verifyNow(
         *       {
         *           errorUrl: 'https://error.com',
         *           successUrl: 'https://success.com',
         *           documentType: 'PASSPORT'
         *       }
         * );
         */
        verifyNow: getVerifyNow(isLoggedIn)
    }), [isLoggedIn]);
};
